import React from "react";
//import Input from "./input";
//import Select from "./select";
//import Radio from "./radio";
import Checkbox from "./checkbox";
//import ReactSelect from "./reactSelect";

function Controler(props){
    const {control, handleChange, hendleDefaultCheck, isMandatory,formikValues, ...rest} = props
    switch (control) {
        case 'input':
             return <Input handleChange={handleChange} {...rest} />
        case 'checkbox':
            return <Checkbox handleChange={handleChange} isMandatory={isMandatory} {...rest} />     
        case 'radio':
            return <Radio handleChange={handleChange} isMandatory={isMandatory} {...rest} />
        case 'textarea':  
        case 'select':
            return <Select handleChange={handleChange} {...rest} />
        case 'react_select':
            return <ReactSelect handleChange={handleChange} formikValues={formikValues} hendleDefaultCheck={hendleDefaultCheck} {...rest} />

        default: return null  
    }


}
export default Controler